// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__gLzC7","with-padding":"Card_with-padding__mn_i5","round":"Card_round__7THN1","square":"Card_square__sL_vo"};